import { useState, useEffect } from 'react'
import { getNationalitysAPI } from '../services/nationalitys'

function UseNationalitys() {
  const [data, setData] = useState([])
  useEffect(() => {
    const getData = async () => {
      const result = await getNationalitysAPI()
      if (!result) return

      const newData = result.result.map((d, i) => {
        return { value: d.id, label: d.nationality }
      })

      setData(newData)
    }
    getData()
  }, [])

  return data
}

export default UseNationalitys
